export default Object.freeze({
  CROWN: 'CROWN',
  MISSING: 'MISSING',
  IMPLANT: 'IMPLANT',
  TO_REMOVE: 'TO_REMOVE',
});
